export function cleanForceLoginFromPath(fullPath?: string): string {
  if (!fullPath) return '/'
  const [pathname, queryString] = fullPath.split('?')
  if (!queryString) return fullPath

  const params = new URLSearchParams(queryString)
  params.delete('forceLogin')
  const remaining = params.toString()
  return remaining ? `${pathname}?${remaining}` : pathname!
}
